import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';

const Skeleton = () => {
  return <div className="bg-surface-200-bg h-[383px] skeleton rounded-500"></div>;
};

const DynamicStoreBanner = dynamic(() => import('./store-banner'), {
  ssr: false,
  loading: Skeleton
});

const StoreBanner = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicStoreBanner skeleton={skeleton} {...props} />;
};

export default StoreBanner;
